import React from 'react';
import LinkListItem from './Item';

import './style.scss';

interface LinkListSubComponents {
  Item: typeof LinkListItem;
}

const LinkList: React.FC & LinkListSubComponents = (props) => {
  const { children } = props;

  return (
    <ul className="LinkList">
      {children}
    </ul>
  );
};

LinkList.Item = LinkListItem;

export default LinkList;
